import { createContext } from 'react';
import { BookingFeatureStore } from '../Storage/BookingFeatureStore';

const BookingFeatureContext = createContext(new BookingFeatureStore());

export default BookingFeatureContext;
